export enum DeviceLoadStatusCode {
    LOAD = 'load',
    UNLOAD = 'unload',
    UNKNOWN = 'unknown',
}
